import axios from "axios";
import "../config";

export default {
  async create(data) {
    return axios.post("/workspaces", data);
  },
  async find({ id }) {
    return axios.get(`/workspaces/${id}`);
  },
  async update(data) {
    return axios.put(`/workspaces/${data.id}`, data);
  },
  async delete(data) {
    return axios.delete("/workspaces", data);
  },
  async getSpotlights({ id }) {
    return axios.get(`/workspaces/${id}/spotlights`);
  },
  async getUsers({ id }) {
    return axios.get(`/workspaces/${id}/users`);
  },
  async getEmbedCode({ id }) {
    return axios.get(`/workspaces/${id}/embed`);
  },
  async updateBillingcard(data) {
    return axios.post("/workspaces/update-billing-card", data);
  },
  async updateSubscription(data) {
    return axios.post("/workspaces/update-subscription", data);
  },
  async paymentMethods({ id }) {
    return axios.get(`/workspaces/${id}/payment-methods`);
  },
  async addPaymentMethod(data) {
    return axios.post("/workspaces/add-payment-method", data);
  },
  async invoiceHistory({ id }) {
    return axios.get(`/workspaces/${id}/invoice-history`);
  },
  async removePaymentMethod(data) {
    return axios.delete(`/workspaces/remove-payment-method`, { data });
  },
  async prorationCheckout({ workspaceId, planId, coupon = '' }) {
    return axios.get(
      `workspaces/${workspaceId}/${planId}/proration-checkout?coupon=${coupon}`
    );
  },
  async newPaymentIntent(data) {
    return axios.post("/workspaces/new-payment-intent", data);
  },
  async pendingInvites({ id }) {
    return axios.get(`workspaces/${id}/pending-invites`);
  },
  async inviteUser(data) {
    return axios.post("workspaces/invite-user", data);
  },
  async removeInvite(data) {
    return axios.post("workspaces/remove-invite", data);
  },
  async acceptInvite(data) {
    return axios.post("workspaces/accept-invite", data);
  },
  async getUsage(id) {
    return axios.get(`/workspaces/${id}/usage`);
  },
};
